import ErrorFallback from 'Components/ErrorFallback'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import useTypedSelector from 'Store'
import { LOGIN_PAGE_PATH } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { FaultReportDetailPage, FaultReportDetailViewPage } from './Pages'

const FaultReportRoot = () => {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route path={`view/:id`} element={<FaultReportDetailViewPage />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/"
        >
          <Route path={`:id`} element={<FaultReportDetailPage />} />
          <Route path={`create`} element={<FaultReportDetailPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}
export default FaultReportRoot
